import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminAuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent {
  username = '';
  password = '';
  error: string | null = null;
  loading = false;

  constructor(
    private readonly auth: AdminAuthService,
    private readonly router: Router,
  ) {}

  async onSubmit(): Promise<void> {
    this.error = null;
    this.loading = true;
    try {
      await this.auth.signIn(this.username, this.password);

      const isAdmin = await this.auth.isAdmin();
      if (!isAdmin) {
        await this.auth.signOut();
        this.error = 'Access denied. Your account is not in the Admins group.';
        return;
      }

      await this.router.navigate(['/']);
    } catch (err: unknown) {
      this.error = err instanceof Error ? err.message : 'Sign-in failed. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}
